import type { BusinessPartnerItem, BusinessPartnerOption } from './type';
const mapBusinessPartnerToOption = (item: BusinessPartnerItem): BusinessPartnerOption => ({
  value: item.businessPartnerId,
  label: item.businessPartnerName,
  item
});
export const mapBusinessPartnersToOptions = (items: readonly BusinessPartnerItem[]): readonly BusinessPartnerOption[] => items.map(mapBusinessPartnerToOption);